import React, { Component, Fragment } from 'react';
import { Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './Complaint.css';
const countyZoneMap = {
  'new york': '1',
  kings: '1',
  bronx: '1',
  queens: '1',
  richmond: '1',
  nassau: '1',
  suffolk: '1',
  westchester: '1',
  orange: '2',
  putnam: '2',
  rockland: '2',
  albany: '2',
  clinton: '2',
  columbia: '2',
  dutchess: '2',
  essex: '2',
  franklin: '2',
  fulton: '2',
  greene: '2',
  hamilton: '2',
  montgomery: '2',
  rensselaer: '2',
  saratoga: '2',
  schenectady: '2',
  schoharie: '2',
  sullivan: '2',
  ulster: '2',
  warren: '2',
  washington: '2',
  broome: '2',
  chenango: '2',
  cortland: '2',
  delaware: '2',
  herkimer: '2',
  jefferson: '2',
  lewis: '2',
  madison: '2',
  oneida: '2',
  onondaga: '2',
  oswego: '2',
  otsego: '2',
  'st. lawrence': '2',
  'st lawrence': '2',
  cayuga: '2',
  allegany: '3',
  cattaraugus: '3',
  chautauqua: '3',
  chemung: '3',
  erie: '3',
  genesee: '3',
  livingston: '3',
  monroe: '3',
  niagara: '3',
  ontario: '3',
  orleans: '3',
  schuyler: '3',
  seneca: '3',
  steuben: '3',
  wayne: '3',
  wyoming: '3',
  yates: '3',
  tioga: '3',
  tompkins: '3'
}

const getZoneByCounty = (county) => {
  const normalizedCounty = (county || '').trim().toLowerCase()
  if (normalizedCounty === '') return '1'
  return countyZoneMap[normalizedCounty] || ''
}

export class Location extends Component {
  static propTypes = {
    suggestions: PropTypes.instanceOf(Array)
  };

  static defaultProps = {
    suggestions: []
  };

  constructor(props) {
    super(props);

    this.state = {
      // The active selection's index
      activeSuggestion: 0,
      // The suggestions that match the user's input
      filteredSuggestions: [],
      // Whether or not the suggestion list is shown
      showSuggestions: false,
      // What the user has entered
      userInput: "",
      userSelection: []
    };
  }

  componentWillReceiveProps(props) {
    if (props.locationObj.displayname === "") {
      this.setState({
        userInput: ''
      });
    }
  }

  showPremiseName = () => {
    return (<input className="form-control" type="text" name="displayname" value={this.props.locationObj.displayname} onChange={this.handleUserInput} ref={(el) => (this.locName = el)} maxLength={400}/>)}

  showAddress = () => {
    return (<input className="form-control" type="text" name="address" value={this.props.locationObj.address} onChange={this.handleUserInput} ref={(el) => (this.locAdd = el)}/>)
  }

  showCity = () => {
    return (<input className="form-control" type="text" name="city" value={this.props.locationObj.city} onChange={this.handleTextOnlyInput} ref={(el) => (this.locCity = el)}/>)
  }

  showZip = () => {
    return (<input className="form-control" type="text" name="zip" value={this.props.locationObj.zip} onChange={this.handleNumberOnlyInput} ref={(el) => (this.locZip = el)} />)}

  handleUserInput = (changeEvent) => {
    const name = changeEvent.target.name;
    const value = changeEvent.target.value;
    this.props.locationChanges(name, value);
    if (name === 'county') {
      this.props.locationChanges('zone', getZoneByCounty(value))
    }
  }

  handleTextOnlyInput = (changeEvent) => {
    if (changeEvent.target.value.length > 0) {
      const onlyText = /^[A-Za-z. ]+$/;
      const reResult = onlyText.test(changeEvent.target.value);
      if (reResult) {
        this.handleUserInput(changeEvent);
      }
    }
    else {
      this.handleUserInput(changeEvent);
    }
  }

  handleNumberOnlyInput = (changeEvent) => {
    if (changeEvent.target.value.length > 0) {
      const onlyNum = /^[0-9\s]+$/;
      const reResult = onlyNum.test(changeEvent.target.value);
      if (reResult) {
        this.handleUserInput(changeEvent);
      }
    }
    else {
      this.handleUserInput(changeEvent);
    }

  }


  makeCountyList = () => {
    return (<select name="county" className="form-control" onChange={this.handleUserInput} value={this.props.locationObj.county}>
        <option value="">- None -</option>
        <option value="albany">Albany</option>
        <option value="allegany">Allegany</option>
        <option value="bronx">Bronx</option>
        <option value="broome">Broome</option>
        <option value="cattaraugus">Cattaraugus</option>
        <option value="cayuga">Cayuga</option>
        <option value="chautauqua">Chautauqua</option>
        <option value="chemung">Chemung</option>
        <option value="chenango">Chenango</option>
        <option value="clinton">Clinton</option>
        <option value="columbia">Columbia</option>
        <option value="cortland">Cortland</option>
        <option value="delaware">Delaware</option>
        <option value="dutchess">Dutchess</option>
        <option value="erie">Erie</option>
        <option value="essex">Essex</option>
        <option value="franklin">Franklin</option>
        <option value="fulton">Fulton</option>
        <option value="genesee">Genesee</option>
        <option value="greene">Greene</option>
        <option value="hamilton">Hamilton</option>
        <option value="herkimer">Herkimer</option>
        <option value="jefferson">Jefferson</option>
        <option value="kings">Kings</option>
        <option value="lewis">Lewis</option>
        <option value="livingston">Livingston</option>
        <option value="madison">Madison</option>
        <option value="monroe">Monroe</option>
        <option value="montgomery">Montgomery</option>
        <option value="nassau">Nassau</option>
        <option value="new york">New York</option>
        <option value="niagara">Niagara</option>
        <option value="oneida">Oneida</option>
        <option value="onondaga">Onondaga</option>
        <option value="ontario">Ontario</option>
        <option value="orange">Orange</option>
        <option value="orleans">Orleans</option>
        <option value="oswego">Oswego</option>
        <option value="otsego">Otsego</option>
        <option value="putnam">Putnam</option>
        <option value="queens">Queens</option>
        <option value="rensselaer">Rensselaer</option>
        <option value="richmond">Richmond</option>
        <option value="rockland">Rockland</option>
        <option value="st lawrence">St. Lawrence</option>
        <option value="saratoga">Saratoga</option>
        <option value="schenectady">Schenectady</option>
        <option value="schoharie">Schoharie</option>
        <option value="schuyler">Schuyler</option>
        <option value="seneca">Seneca</option>
        <option value="steuben">Steuben</option>
        <option value="suffolk">Suffolk</option>
        <option value="sullivan">Sullivan</option>
        <option value="tioga">Tioga</option>
        <option value="tompkins">Tompkins</option>
        <option value="ulster">Ulster</option>
        <option value="warren">Warren</option>
        <option value="washington">Washington</option>
        <option value="wayne">Wayne</option>
        <option value="westchester">Westchester</option>
        <option value="wyoming">Wyoming</option>
        <option value="yates">Yates</option></select>);
  }

  clearSearch = () => {
    this.setState({
        // The active selection's index
        activeSuggestion: 0,
        // The suggestions that match the user's input
        filteredSuggestions: [],
        // Whether or not the suggestion list is shown
        showSuggestions: false,
        // What the user has entered
        userInput: "",
        userSelection: []
      }, () => {
      });

    const emptyLocation = {
      serialnumber: '',
      premisesname: '',
      displayname: '',
      licensepermitid: '',
      dba: '',
      address: '',
      city: '',
      zip: '',
      county: '',
      zone: '1',
      key: ''
    };

    this.handleLocationUpdate(emptyLocation);
    this.locName.value = '';
    this.locCity.value = '';
    this.locZip.value = '';
    this.locAdd.value = '';
  }

  onChange = (e) => {
    const userInput = e.currentTarget.value;
    let filteredSuggestions = [];


    const premisesSuggestions = this.props.suggestions.map((item) => ({
      displayname: item.doing_business_as_dba !== '' ? item.doing_business_as_dba : item.premises_name,
      premisesname: item.premises_name || '',
      dba: item.doing_business_as_dba || '',
      serialnumber: item.license_serial_number || '',
      licensepermitid: item.license_certificate_number || '',
      key: item.license_serial_number + '_' + item.license_certificate_number,
      address: item.address || '',
      city: item.city || '',
      zip: item.zip || '',
      county: item.county_name_licensee === undefined ? '' : item.county_name_licensee.toLowerCase(),
      zone: getZoneByCounty(item.county_name_licensee)
    }));

    if (userInput.length > 3) {
      filteredSuggestions = premisesSuggestions.filter((o) =>
        Object.keys(o).some((k) => o[k].toLowerCase().indexOf(userInput.toLowerCase()) > -1))
    }

    // Update the user input and filtered suggestions, reset the active
    // suggestion and make sure the suggestions are shown
    this.setState({
      activeSuggestion: 0,
      filteredSuggestions,
      showSuggestions: true,
      userInput: e.currentTarget.value
    });
  };

  handleLocationUpdate = (data) => {
    Object.keys(data).forEach((key) => {
      let value = data[key];
      this.props.locationChanges(key, value);
    });
  }


  // Event fired when the user clicks on a suggestion
  onClick = (e) => {
    // Update the user input and reset the rest of the state
    const found = e.currentTarget.innerText;
    var foundObject = JSON.parse(e.currentTarget.dataset.value);

    this.setState({
      activeSuggestion: 0,
      filteredSuggestions: [],
      showSuggestions: false,
      userInput: found,
      userSelection: foundObject
    }
    );

    this.handleLocationUpdate(foundObject);
  };

  // Event fired when the user presses a key down
  onKeyDown = (e) => {
    const usertext = e.currentTarget.dataset.value;
    const { activeSuggestion, filteredSuggestions } = this.state;

    // User pressed the enter key, update the input and close the
    // suggestions
    if (e.keyCode === 13 && usertext.length > 3) {
      this.setState({
        activeSuggestion: 0,
        showSuggestions: false,
        userInput: filteredSuggestions[activeSuggestion].name + ' - ' + filteredSuggestions[activeSuggestion].address + ', ' + filteredSuggestions[activeSuggestion].city
      });
    }
    // User pressed the up arrow, decrement the index
    else if (e.keyCode === 38) {
      if (activeSuggestion === 0) {
        return;
      }

      this.setState({ activeSuggestion: activeSuggestion - 1 });
    }
    // User pressed the down arrow, increment the index
    else if (e.keyCode === 40) {
      if (activeSuggestion - 1 === filteredSuggestions.length) {
        return;
      }

      this.setState({ activeSuggestion: activeSuggestion + 1 });
    }
  };
  showLocationValidationMessage = () => {
    if (this.props.validationMsgLoc.length === 0) return null;
    return (<Alert ref="alertVisible" className="alert alert-danger" dismissible="true"><ul>  {this.props.validationMsgLoc.map((type) => (<li key={type}>{type}</li>  ))}</ul>{''}</Alert>)
    }

  render() {
    const {
      onChange,
      onClick,
      onKeyDown,
      state: {
        activeSuggestion,
        filteredSuggestions,
        showSuggestions,
        userInput
      }
    } = this;

    let suggestionsListComponent;

    if (showSuggestions && userInput.length > 3) {
      if (filteredSuggestions.length > 0) {
        suggestionsListComponent = (
          <ul className="list-group suggestions">
            {filteredSuggestions.map((suggestion, index) => {
              var className = "list-group-item";

              // Flag the active suggestion with a class
              if (index === activeSuggestion) {
                className = "list-group-item";
              }

              return (
                <li
                  className={className}
                  key={suggestion.key}
                  onClick={onClick}
                  data-value={JSON.stringify(suggestion)}
                >
                  <h4>{suggestion.premisesname}</h4>
                  {suggestion.dba}<br />
                  {suggestion.address}, {suggestion.city}, NY {suggestion.zip}
                </li>
              );
            })}
          </ul>
        );
      } else {
        suggestionsListComponent = (
          <Alert ref="alertVisible" className="alert alert-warning" dismissible="true">
            <b>Sorry</b>, your search did not yield any known licensed premises. You may provide the premises name and/or location details to the best of your knowledge.
          </Alert>
        );
      }
    }

    return (
      <div className="container">
        <div className="row mt-5">
          <fieldset id="step2">
            <legend><span className="fieldset-legend">Step 2 of 4 - Premises Information</span></legend>
            <div className="col-sm-12">
              <h3>Help us identify the premises involved using the search below.</h3>
              <br />{this.showLocationValidationMessage()}
              <div className="col-md-6">
                <div className="form-group mt-2">
                  <Fragment>
                    <div className="input-group">
                      <input
                        className="form-control"
                        type="text"
                        onChange={onChange}
                        onKeyDown={onKeyDown}
                        value={userInput}
                        placeholder="Enter a premises name or address (min 4 characters)"
                      />
                      <span className="input-group-btn">
                        <button className="btn btn-outline-primary btn-clear" type="button" onClick={this.clearSearch}>Clear</button>
                      </span>
                    </div>
                    {suggestionsListComponent}
                  </Fragment>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group mt-2">
                  <div className="form-horizontal row" >
                    <label className=" control-label col-md-4" htmlFor="Displayname">Name</label>
                    <div className="col-md-8">
                        {this.showPremiseName()}
                    </div>
                  </div >
                  <div className="form-horizontal row">
                    <label className="control-label col-md-4" htmlFor="Address">Address</label>
                    <div className="col-md-8">
                        {this.showAddress()}
                    </div>
                  </div >
                  <div className="form-horizontal row">
                    <label className="control-label col-md-4" htmlFor="City">City</label>
                    <div className="col-md-8">
                        {this.showCity()}
                    </div>
                  </div >
                  <div className="form-horizontal row">
                    <label className="control-label col-md-4" htmlFor="Zip">Zip</label>
                    <div className="col-md-8">
                        {this.showZip()}
                    </div>
                  </div >
                  <div className="form-horizontal row">
                    <label className="control-label col-md-4" htmlFor="County" >County</label>
                    <div className="col-md-8">
                        {this.makeCountyList()}
                    </div>
                  </div>
                  <br />
                  <div className="form-horizontal row">
                    <label className="control-label col-md-4"> </label>
                    <div className="col-md-8">
                      <button className="btn btn-outline-primary" type="button" onClick={this.clearSearch}>Reset</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    );
  }
}

export default Location;




// WEBPACK FOOTER //
// ./src/components/Location.js